import { API } from 'aws-amplify'
import { gql } from 'graphql-tag'

const getUserDefaultWorkspace = async (id) => {
  const { data, errors } = await API.graphql({
    query: getUserDefaultWorkspaceQuery,
    variables: { id }
  })

  if (errors) throw errors

  return data?.getUserById
}

const getUserDefaultWorkspaceQuery = gql`
  query getUserDefaultWorkspace($id: ID!) {
    getUserById(id: $id) {
      id
      defaultWorkspaceId
    }
  }
`

export { getUserDefaultWorkspace, getUserDefaultWorkspaceQuery }
